import PropTypes from 'prop-types'
import { createElement, useEffect, useState } from 'react'
import { useAccordionToggle } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import { actions } from '@/reducers/accordion'
import store from '@/store'

export const Toggle = ({
  as,
  children,
  eventKey,
  className,
  defaultExpanded
}) => {
  const currentKey = useSelector(state => state.accordion.eventKey)
  const [isExpanded, setExpanded] = useState(false)
  const classes = `${className} ${isExpanded && 'expanded'}`

  useEffect(() => {
    if (currentKey !== eventKey) { setExpanded(false) }
  }, [currentKey])

  useEffect(() => {
    if (defaultExpanded) { setExpanded(true) }
  }, [defaultExpanded])

  const clickEvent = useAccordionToggle(eventKey, () => {
    store.dispatch(actions.updateAccordionEventKey(eventKey))
    setExpanded(!isExpanded)
  })

  return createElement(
    as,
    {
      'aria-controls': eventKey,
      'aria-expanded': isExpanded,
      className: classes,
      onClick: clickEvent
    },
    children
  )
}

Toggle.propTypes = {
  as: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  className: PropTypes.string,
  defaultExpanded: PropTypes.bool.isRequired,
  eventKey: PropTypes.string.isRequired
}
